import { getShouldShowWizard, Wizard } from 'platform-components';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as userActions from 'common.components/user/actions';
import { Hint } from 'common.components/user/typings';

export const WizardContainer = () => {
    const shouldShowWizard = useSelector(getShouldShowWizard);
    const dispatch = useDispatch();
    const setWizardHints = (hint: Hint) => dispatch(userActions.setWizardHints(hint));

    if (shouldShowWizard) {
        return <Wizard setWizardHints={setWizardHints} />;
    }

    return null;
};
